export default {
    namespaced: true,
    state: {
        isSliderExpand: false
    },
    mutations: {
        CHANGE_NAV_SLIDER_EXPAND: (state, val) => {
            state.isSliderExpand = val;
        }
    }
};